import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-overviews',
  templateUrl: './skeleton-overviews.component.html',
  styleUrls: ['./skeleton-overviews.component.scss']
})
export class SkeletonOverviewsComponent implements OnInit{

	@Input() length: number = 1
	@Input() height: string = '166px'

	// The density of the list these placeholders stand in for. Defaults to the
	// count the old bootstrap ladder produced on a wide screen, so a page that
	// does not pass one keeps the layout it had.
	@Input() cols: number = 4

	// The shape of one placeholder. A restream row is a fixed strip; a card cover
	// is a ratio of whatever width its grid column ended up with, so a fixed height
	// there would stop matching the moment the density changes.
	@Input() ratio: string = ''

	get itemTheme(){
		const base = {'position': 'relative', 'margin': 0, 'width': '100%', 'border-radius': 'var(--card-radius)'}
		return this.ratio
			// height:auto matters - the library sets a height of its own, and a box
			// with an explicit height ignores aspect-ratio entirely.
			? Object.assign({}, base, {'height': 'auto', 'aspect-ratio': this.ratio})
			: Object.assign({}, base, {'height': this.height})
	}

        items = []
        ngOnInit() { 
	
		this.items = Array(this.length).fill(0)

	}


}
